<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Refinery Balance</h4>
    <dx-data-grid class="fixGridHeight" id="RefineryBalanceGrid" [dataSource]="refineryBalances" [showRowLines]="true"
        [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

        <dxi-column dataField="siteID" alignment="center" cellTemplate="cellTemplateSiteID">
        </dxi-column>
        <div *dxTemplate="let item of 'cellTemplateSiteID'">
            <a href="" (click)="redirectToSite($event)">{{item.data.siteID}}</a>
        </div>
        <dxi-column dataField="companyName" [allowEditing]="true" alignment="center" cellTemplate="cellTemplate">
        </dxi-column>
        <div *dxTemplate="let item of 'cellTemplate'">
            <a [routerLink]="['/refinerybalance/', item.data.siteID]">{{item.data.companyName}}</a>
        </div>
        <dxi-column dataField="countryName" caption="Country"></dxi-column>
        <dxi-column dataField="province" caption="State/Province/County"></dxi-column>
        <dxi-column dataField="city" caption="Town/City"></dxi-column>
    </dx-data-grid>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>